import call from "../../../dashboard/service/http";
import constants from "./specializationConstants";
export default {
  state: {
    specializations: [],
    specialization: {},
  },
  mutations: {
    SET_SPECIALIZATION: (state, payload) => {
      state.specializations = payload;
    },
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    specializationGetters: (state) => (value) => state[value],
  },
  actions: {
    editspecialization: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("patch", constants.editspecialization, data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          // back to specialization
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    submitspecialization: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.submit, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
          // back to specialization
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    deletespecialization: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("delete", constants.deletespecialization(data), data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
